// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Organismes attestations comptes à jour
export default class AttestationDef  {
  // Identifiant unique
  public id: number;
  // Organisme
  public organisme: string;
  // Caisse
  public caisse: string;
  // adresse mail
  public mail: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.organisme = '';
    this.caisse = '';
    this.mail = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: AttestationDef): AttestationDef {
    const newAttestationDef: AttestationDef = new AttestationDef();
    newAttestationDef.id = obj.id;
    newAttestationDef.organisme = obj.organisme;
    newAttestationDef.caisse = obj.caisse;
    newAttestationDef.mail = obj.mail;
    newAttestationDef.createId = obj.createId;
    newAttestationDef.failed = obj.failed;
    newAttestationDef.canUpdate = obj.canUpdate;
    newAttestationDef.canDelete = obj.canDelete;
    newAttestationDef.display = obj.display;
    newAttestationDef.notifDefType = obj.notifDefType;
    return newAttestationDef;
  }

  public toJsonAttestationDef (): string {
    const json = {
      organisme: this.organisme,
      caisse: this.caisse,
      mail: this.mail,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromAttestationDef (obj: AttestationDef): void {
    this.id = obj.id;
    this.organisme = obj.organisme;
    this.caisse = obj.caisse;
    this.mail = obj.mail;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareAttestationDef (value: AttestationDef): boolean {
    return (this.toJsonAttestationDef() == value.toJsonAttestationDef());
  }

  public cloneAttestationDef (): AttestationDef {
    return AttestationDef.fromJson(this);
  }

  public createForStoreAttestationDef (): Promise<AttestationDef> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/attestationdefs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAttestationDef(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreAttestationDef (): Promise<AttestationDef> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/attestationdefs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAttestationDef(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreAttestationDef (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/attestationdefs/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/attestationdefs/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/AttestationDefs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = AttestationDef.fromJson(listData.reccords[0] as AttestationDef);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<AttestationDef> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/AttestationDefs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = AttestationDef.fromJson(listData.reccords[0] as AttestationDef);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(attestationDefs: AttestationDef[]) {
  }
}
